// src/components/Experience.js

import React from 'react';
import '../data/Experience.css';
import { Container, Row, Col } from 'react-bootstrap';
import { useState } from 'react';
import { useTheme, DARK, LIGHT } from '../context/ThemeContext';




const experiences = [
  {
    position: 'Senior Software Developer',
    company: 'General Data',
    companyUrl: 'https://www.general-data.com/',  
    duration: 'Nov 2024 – Present',
    current: true,
    location: 'OH, USA',
    description:
      'Building healthcare-focused enterprise web applications using Java and Spring Boot for backend services, with Angular for dynamic front-end development, specializing in API integration, efficient data management, and performance optimization.',
  },
  {
    position: 'Senior Software Engineer',
    company: 'iSGM',
    companyUrl: 'https://www.isgm2.com',         
    duration: 'Apr 2019 – Jun 2022',
    current: false,
    location: 'Myanmar',
    description:
      'Led Java Spring Boot backend development, crafting secure RESTful APIs with Spring Security and implementing efficient state management with React.js.',
  },
  {
    position: 'Software Engineer',
    company: 'iSGM',
    companyUrl: 'https://www.isgm2.com/',      
    duration: 'Apr 2018 – Apr 2019',
    current: false,
    location: 'Myanmar',
    description:
      'Optimized relational databases, automated backend processes with Spring Boot, conducted unit testing using JUnit, and produced comprehensive software documentation.',
  },
  {
    position: 'Software Developer Intern',
    company: 'TrustLink',
    companyUrl: 'https://trustlinkmm.com/',    
    duration: 'May 2017 – Aug 2017',
    current: false,
    location: 'Myanmar',
    description:
      'Developed a customer service solutions using VB.Net, Crystal Reports and executed test cases across various business scenarios.',
  },
];

const Experience = () => {
  const { isDark } = useTheme();
  const t = isDark ? DARK : LIGHT;
  const [hoveredCard, setHoveredCard] = useState(null);
 
  return (
    <section id="experience" style={{ background: t.bg, padding: '60px 0', transition: 'background 0.3s' }}>
      <Container>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '36px' }}>
          {/* <div style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '3px', textTransform: 'uppercase', color: t.accent, marginBottom: '8px' }}>
            Career
          </div> */}
          <div style={{ fontSize: '26px', fontWeight: 700, letterSpacing: '3px', textTransform: 'uppercase', color: t.accent, marginBottom: '8px'  }}> 🌏 Work Experience 🌏 </div>
        </div>
 
        
        {experiences.map((exp, i) => {
          const hovered = hoveredCard === i;
          return (
            <div
              key={i}
              onMouseEnter={() => setHoveredCard(i)}
              onMouseLeave={() => setHoveredCard(null)}
              style={{
                display: 'grid',
                gridTemplateColumns: '130px 1fr',
                gap: '0 22px',
                marginBottom: '12px',
                background: t.bgAlt,
                border: `1px solid ${hovered ? t.borderHover : t.border}`,
                borderRadius: '12px',
                padding: '20px 24px 20px 26px',
                position: 'relative',
                overflow: 'hidden',
                transition: 'all 0.2s ease',
                transform: hovered ? 'translateX(5px)' : 'translateX(0)',
                boxShadow: hovered ? t.shadow : 'none',
              }}
            >
              {/* Left accent bar */}
              <div style={{
                position: 'absolute', left: 0, top: 0, bottom: 0, width: '3px',
                background: `linear-gradient(180deg, ${t.accent}, ${t.accentPurple})`,
                borderRadius: '3px 0 0 3px',
              }} />
 
              {/* Left: duration + badge */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', paddingTop: '2px' }}>
                <span style={{ fontSize: '14px', color: t.textSub, lineHeight: 1.65, fontWeight: 500 }}>
                  {exp.duration}
                </span>
                {exp.current && (
                  <span style={{
                    display: 'inline-block',
                    background: t.badgeBg, border: `1px solid ${t.badgeBorder}`,
                    color: t.badgeColor, fontSize: '10px', fontWeight: 600,
                    letterSpacing: '1px', padding: '2px 8px',
                    borderRadius: '20px', textTransform: 'uppercase',
                    width: 'fit-content',
                  }}>
                    Current
                  </span>
                )} 
                {exp.location && (
                  <span style={{ fontSize: '11px', color: t.textSub, display: 'flex', alignItems: 'center', gap: '4px' }}>
                    📍 {exp.location}
                  </span>
                )}
              </div>
 
              {/* Right: content */}
              <div>
                <div style={{ fontSize: '16px', fontWeight: 600, color: t.text, marginBottom: '4px' }}>
                  {exp.position}
                </div>
                <a
                  href={exp.companyUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    fontSize: '13px', color: t.accent, fontWeight: 500,
                    textDecoration: 'none', display: 'inline-flex',
                    alignItems: 'center', gap: '4px', marginBottom: '10px',
                  }}
                  onMouseEnter={e => e.currentTarget.style.textDecoration = 'underline'}
                  onMouseLeave={e => e.currentTarget.style.textDecoration = 'none'}
                >
                  {exp.company}
                  <span style={{ fontSize: '11px', opacity: 0.7 }}>↗</span>
                </a>
                <div style={{ fontSize: '13.5px', color: t.textSub, lineHeight: 1.75 }}>
                  {exp.description}
                </div>
              </div>
            </div>
          );
        })}
      </Container>
    </section>
  );
};

export default Experience;
